import React from "react";
import Card from "../../../../componentLibrary/Card";
import SectionTitle from "./SectionTitle";
import LoadingWrapper from "./LoadingWrapper";

interface StatItem {
  label: string;
  value: string | number;
}

interface StatsCardProps {
  title: string;
  stats: StatItem[];
  loading?: boolean;
  /** Tailwind grid class. Defaults to "grid-cols-2 md:grid-cols-4". */
  gridCols?: string;
  children?: React.ReactNode;
}

const StatBox: React.FC<StatItem> = ({ label, value }) => (
  <div className="bg-gray-100 rounded-lg p-4 text-center">
    <div className="text-2xl font-bold text-electrum-300">
      {typeof value === "number" ? value.toLocaleString() : value}
    </div>
    <div className="text-xs text-gray-600 mt-1">{label}</div>
  </div>
);

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  stats,
  loading = false,
  gridCols = "grid-cols-2 md:grid-cols-4",
  children,
}) => (
  <Card className="p-5">
    <SectionTitle>{title}</SectionTitle>
    <LoadingWrapper loading={loading}>
      <div className={`grid ${gridCols} gap-4`}>
        {stats.map((stat) => (
          <StatBox key={stat.label} label={stat.label} value={stat.value} />
        ))}
      </div>
      {children}
    </LoadingWrapper>
  </Card>
);

export { StatBox };
export default StatsCard;
